import { CountryCode } from '@api/index';
import { injectTSDI } from './tsdi';
import { I18nStore } from './i18n-store';

const labelsMap = {
    firstname: 'customer.firstname',
    lastname: 'customer.lastname',
    gender: 'customer.gender',
    email: 'customer.email',
    phone: 'customer.phone',
    street: 'customer.street',
    houseNumber: 'customer.house.number.short',
    zipCode: 'customer.zipcode',
    city: 'customer.city',
    countryCode: 'customer.country',
    day: 'commons.day',
    month: 'commons.month',
    year: 'commons.year',
    accountHolder: 'bankaccount.holder',
    iban: 'commons.iban',
    creditCardTokenizationReference: 'onlinepages.paymentchoice.creditcard',

    taxId: 'onlinepages.tax.information',
    spanishTaxId: 'commons.dni.nie',
    codiceFiscale: 'commons.codicefiscale',

    placeOfBirth: 'commons.place.of.birth',
    countryOfBirth: 'commons.country.of.birth',
    documentType: 'customer.document.type',
    documentNumber: 'customer.document.number',
    province: 'commons.province.code',

    streetType: 'commons.street.type',
    block: 'commons.block',
    portal: 'commons.portal',
    stairway: 'commons.stair',
    floor: 'commons.floor',
    door: 'commons.door',

    sepaSignature: 'commons.signature',
    gdprAgreement: 'onlinepages.agreement.checkbox',
    sepaAgreement: 'onlinepages.sepa.agreement.checkbox',
    signature: 'commons.signature',

    referralCode: 'commons.referral.code',
    voucherCode: 'commons.voucher.code'
};

export type FiedName = keyof typeof labelsMap;

export const fieldLabel = (fieldName: FiedName) => {
    const { __ } = injectTSDI(I18nStore);
    return __(labelsMap[fieldName]);
};

export const taxIdLabel = (countryCode: CountryCode | undefined) => {
    switch (countryCode) {
        case 'IT':
            return fieldLabel('codiceFiscale');
        case 'ES':
            return fieldLabel('spanishTaxId');
        default:
            console.warn(`Missing tax id name for country code ${countryCode}`);
            return fieldLabel('taxId');
    }
};
